import { initialState } from "../dashboard.slice";

const resetDashboard = () => {
    return initialState;
}

export default resetDashboard